import dayjs from 'dayjs';
import ptBrLocale from '~/utils/dayjs-pt-br';

export default defineNuxtPlugin(() => {
  dayjs.locale(ptBrLocale);
});
